export const MG_TRENDING_CAROUSEL_DATA = [
  {
    id: 1,
    label: 'Creator',
    link: '/motion-graphics/category/creator',
    image: 'https://cdn.uppbeat.io/images-2025/mg_creator.png',
  },
  {
    id: 2,
    label: 'Intros',
    link: '/motion-graphics/category/intros',
    image: 'https://cdn.uppbeat.io/images-2025/mg_intros.png',
  },
  {
    id: 3,
    label: 'Subscribe Buttons',
    link: '/motion-graphics/category/buttons/social-media/subscribe-buttons',
    image: 'https://cdn.uppbeat.io/images-2025/mg_subscribe-buttons.png',
  },
  {
    id: 6,
    label: 'Transitions',
    link: '/motion-graphics/category/transitions',
    image: 'https://cdn.uppbeat.io/images-2025/mg_transitions.png',
  },
  {
    id: 9,
    label: 'Overlays',
    link: '/motion-graphics/category/overlays',
    image: 'https://cdn.uppbeat.io/images-2025/mg_overlays.png',
  },
  {
    id: 4,
    label: 'Reactions',
    link: '/motion-graphics/category/reactions',
    image: 'https://cdn.uppbeat.io/images-2025/mg_reactions.png',
  },
  {
    id: 5,
    label: 'Elements',
    link: '/motion-graphics/category/elements',
    image: 'https://cdn.uppbeat.io/images-2025/mg_elements.png',
  },
  {
    id: 7,
    label: 'Characters & Objects',
    link: '/motion-graphics/category/characters-and-objects',
    image: 'https://cdn.uppbeat.io/images-2025/mg_characters-objects.png',
  },
];
